// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pz-1";
export var stateContainer = "_pz-0";